(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PainelEdicaoAplicacaoCtrl', PainelEdicaoAplicacaoController);

  PainelEdicaoAplicacaoController.$inject = [
    '$scope',
    '$rootScope',
    '$q',
    'MessagesService',
    'MaquinasService',
    'RecomendacoesService',
    'UnidadesService',
    'LoadingService',
    'ProdutoModalService',
    '$location',
    '$routeParams',
    'AplicacoesService',
    'ItensService',
    'DepositosService',
    'DecimalsService'
  ];

  // eslint-disable-next-line max-lines-per-function,max-params
  function PainelEdicaoAplicacaoController($scope, $rootScope, $q,
    MessagesService, MaquinasService, RecomendacoesService,
    UnidadesService, LoadingService, ProdutoModalService,
    $location, $routeParams, AplicacoesService, ItensService,
    DepositosService, DecimalsService, MESSAGE_INVALID_PRODUCT, MESSAGE_WITHOUT_PRODUCT, MIN_DOSE_VALOR) {
    const vm = this;
    $scope.isDecimalV2Enabled = DecimalsService.isDecimalV2Enabled();
    vm.isDecimalV2Enabled = $scope.isDecimalV2Enabled;

    // Controller data
    vm.application = null;
    vm.aplicacao = null;
    vm.glebas = [];
    vm.atividades = [];
    vm.safras = [];
    vm.produtos = null;
    vm.allProdutos = null;
    vm.maquinas = [];
    vm.loadingAplicacao = true;
    vm.newData = {
      atividade: null,
      safra: null,
      produtos: [],
      area: null,
      gleba: null,
      maquina: null,
      observacao: null,
      dataInicial: null,
      horaInicial: null,
      dataFinal: null,
      horaFinal: null
    };
    vm.calendar = {
      format: 'dd/MM/yyyy',
      startOpen: false,
      endOpen: false
    };
    vm.datePickerOptions = {
      showWeeks: false
    };
    vm.selectedProduct = null;
    vm.loadingProdutos = false;
    vm.searchProduto = null;
    vm.tipoOperacao = null;
    vm.hasDepositInUse = false;

    // Bindable functions
    vm.changeSafra = changeSafra;
    vm.changeAtividade = changeAtividade;
    vm.changeArea = changeArea;
    vm.searchProdutos = searchProdutos;
    vm.addProduto = addProduto;
    vm.stockIsNegative = stockIsNegative;
    vm.changeDose = changeDose;
    vm.fixDose = fixDose;
    vm.changeQuantidadeTotal = changeQuantidadeTotal;
    vm.fixQuantidadeTotal = fixQuantidadeTotal;
    vm.startEditDose = startEditDose;
    vm.startEditQuantidadeTotal = startEditQuantidadeTotal;
    vm.removeProduto = removeProduto;
    vm.specifyProductArea = specifyProductArea;
    vm.addLote = addLote;
    vm.getLotes = getLotes;
    vm.openProductModal = openProductModal;
    vm.cancel = cancel;
    vm.save = save;
    vm.toNumber = toNumber;
    vm.changeConsumo = changeConsumo;

    // Function declarations

    // eslint-disable-next-line max-lines-per-function
    function loadData() {
      const promises = [];

      vm.safras = $rootScope.safras;
      vm.newData.safra = _.find(vm.safras, { id: vm.aplicacao.allData.safra.id });

      // Busca todos os produtos para pegar a quantidade em estoque
      const produtosIds = vm.aplicacao
        .allData
        .itens
        .map((produto) => produto.item_codigo);
      promises.push(searchProdutos({
        ids: produtosIds,
        data: vm.aplicacao.dt_ini
      }).then(() => {
        updateProdutos(vm.newData.produtos);
        vm.fatorDose = vm.aplicacao.allData.fatorDose || 1;
      }));

      promises.push(getAtividadesPeriodo());

      promises.push(loadMaquinas());

      promises.push(useDepositInUse());

      return $q.all(promises);
    }

    function getAtividadesPeriodo(findAttributes = true) {
      return RecomendacoesService.listAtividadesPeriodo({
        ignore_open: true,
        safra: vm.aplicacao.allData.safra.id
      }).then((data) => {
        vm.atividades = data;
        if (findAttributes) {
          vm.newData.atividade = _.find(vm.atividades, { id: vm.aplicacao.allData.atividade.id });
          vm.newData.gleba = vm.aplicacao.gleba;
        }
        changeAtividade();
      });
    }

    function loadMaquinas() {
      if (vm.tipoOperacao === $rootScope.parametros.operacao_pulverizacao.id) {
        return MaquinasService.listSprayers().then((response) => {
          const { data } = response;
          vm.maquinas = data;
          vm.newData.maquina = _.find(vm.maquinas, {
            id: _.get(vm.aplicacao, 'allData.atributo.maquina.id')
          });
        });
      }
      return MaquinasService.list().then((response) => {
        const { data } = response;
        vm.maquinas = data;
        vm.newData.maquina = _.find(vm.maquinas, {
          id: _.get(vm.aplicacao, 'allData.atributo.maquina.id')
        });
      });
    }

    function setupData() {
      let start = null;
      let end = null;
      if (vm.aplicacao.allData) {
        const iniciadoEm = _.get(vm.aplicacao, 'allData.atributo.iniciado_em', vm.aplicacao.allData.dt_ini);
        const encerradoEm = _.get(vm.aplicacao, 'allData.atributo.encerrado_em', vm.aplicacao.allData.dt_fim);
        start = moment(iniciadoEm).toDate();
        end = moment(encerradoEm).toDate();
      }

      const capacidade = +(vm.aplicacao.allData.capacidade_tanque ||
        _.get(vm.aplicacao.allData.atributo, 'capacidade_tanque', 0));

      const newData = {
        ...vm.newData,
        produtos: vm.aplicacao.allData.itens.slice(),
        gleba: vm.aplicacao.gleba,
        area: +vm.aplicacao.area || 0,
        newArea: +vm.aplicacao.area || 0,
        observacao: vm.aplicacao.allData.obs,
        dataInicial: start,
        dataFinal: end,
        horaInicial: start,
        horaFinal: end,
        tipoConsumo: vm.aplicacao.nr_tanques > 0 ? { id: 'tanque' } : null,
        nr_tanques: +vm.aplicacao.nr_tanques,
        vazao: +vm.aplicacao.allData.vazao,
        capacidade
      };

      return newData;
    }

    function changeSafra() {
      resetAtividade();
      LoadingService.showLoading();
      getAtividadesPeriodo(false).finally(LoadingService.hideLoading);
    }

    function resetAtividade() {
      vm.atividades = [];
      vm.newData.atividade = null;
      changeAtividade();
    }

    function changeAtividade() {
      vm.glebas = [];
      if (vm.newData.atividade) {
        const glebas = vm.newData.atividade.glebas;
        vm.glebas = RecomendacoesService.listGlebas(glebas);
        if (vm.newData.gleba) {
          vm.newData.gleba = _.find(vm.glebas, { id: vm.newData.gleba.id });
        }
      } else {
        vm.newData.gleba = null;

        const operacaoCorrecaoSolo = $rootScope.parametros.operacao_correcao_solo || {};
        if (operacaoCorrecaoSolo.id === vm.aplicacao.cd_operacao) {
          vm.newData.gleba = vm.aplicacao.gleba;
        }
      }
    }

    function changeArea() {
      vm.newData.produtos = vm.newData.produtos.map((produto) => {
        if (toNumber(produto.qt_area) === toNumber(vm.newData.area)) {
          produto.qt_area = vm.newData.newArea;
        }
        const areaProduto = getArea(produto);
        if ($scope.isDecimalV2Enabled) {
          const qtCalc = DecimalsService.roundForCalculation(
            +produto.qt_dose * areaProduto,
            DecimalsService.DECIMAL_PLACES_CALCULATION
          );
          produto.qt_total = DecimalsService.truncateDoseOrQuantity(qtCalc);
        } else {
          produto.qt_total = Number((toNumber(produto.qt_dose) * areaProduto).toFixed(4));
        }
        return produto;
      });
      vm.newData.area = vm.newData.newArea;
    }

    function toNumber(str) {
      const ret = Number((str || '').toString().replace(',', '.'));

      if (isNaN(ret)) {
        throw new Error('Valor inválido');
      }

      return ret;
    }

    function getArea(produto) {
      return produto.qt_area || toNumber(vm.newData.area);
    }

    function normalizeProdutosLotes(produtos) {
      return (produtos || []).map(function(produto) {
        if (Array.isArray(produto.lotes)) {
          produto.lotes = mapApiLotesToUiFormat(produto.lotes);
        }
        return produto;
      });
    }

    function searchProdutos($select) {
      vm.searchProduto = $select.search;
      vm.produtos = null;
      vm.allProdutos = null;
      if ($select.ids || vm.searchProduto.length >= 3) {
        vm.loadingProdutos = true;

        const params = getSearchParams($select);
        params.nao_considerar_aplicacao_id = vm.aplicacao.id;
        return RecomendacoesService
          .listItemsBalance(params)
          .then(function(data) {
            vm.allProdutos = normalizeProdutosLotes(data.data);
            vm.produtos = vm.allProdutos.filter((produto) => {
              if (!produto.controla_lote) {
                return !findProduto(vm.newData.produtos, produto);
              }
              return true;
            });
          })
          .catch(function(error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          })
          .finally(function() {
            vm.loadingProdutos = false;
          });
      }
    }

    function getSearchParams($select) {
      const params = {
        descricao: $select.search,
        gleba_id: (vm.newData && vm.newData.gleba) ? vm.newData.gleba.id : null,
        operacao_item: getOperacaoItemEstoque()
      };

      if ($select.ids) {
        params.tipo_item = 1;
        params.item = $select.ids.join(',');
      }

      params.data = vm.newData.dataInicial;

      return params;
    }

    function findProduto(itens, produto) {
      // eslint-disable-next-line complexity
      return itens.find((item) => (typeof item.id !== 'undefined' && item.id === produto.id) ||
        (typeof item.item_id !== 'undefined' && item.item_id === produto.id) ||
        (typeof item.item_codigo !== 'undefined' && item.item_codigo === produto.id) ||
        (typeof produto.id !== 'undefined' && produto.id === item.id) ||
        (typeof produto.item_id !== 'undefined' && produto.item_id === item.id) ||
        (typeof produto.item_codigo !== 'undefined' && produto.item_codigo === item.id));
    }

    function addProduto($select) {
      if ($select && $select.id) {
        const produto = findProduto(vm.newData.produtos, $select);
        if (produto && !$select.controla_lote) {
          MessagesService.alert('Este produto já foi inserido na aplicação atual');
        } else {
          $select.item_codigo = $select.id;
          $select.item_tipo = $select.tipo;
          changeDose($select);
          updateProduto($select).then(() => {
            vm.newData.produtos.push($select);
          });
        }
      }
      vm.selectedProduct = null;
    }

    function changeDose(produto) {
      const areaProduto = getArea(produto);
      let quantidadeTotal = 0;

      if ($scope.isDecimalV2Enabled) {
        const quantidadeTotalCalculated = DecimalsService.roundForCalculation(
          +produto.qt_dose * areaProduto,
          DecimalsService.DECIMAL_PLACES_CALCULATION
        );
        quantidadeTotal = DecimalsService.truncateDoseOrQuantity(quantidadeTotalCalculated);
      } else {
        quantidadeTotal = Number((toNumber(produto.qt_dose) * areaProduto).toFixed(4));
      }

      produto.qt_total = quantidadeTotal / vm.fatorDose;
    }

    function updateProdutos(produtos) {
      const promises = [];
      produtos.forEach((produto) => promises.push(updateProduto(produto)));
      return $q.all(promises);
    }

    function updateDescricaoProduto(produto) {
      const foundProduct = findProduto(($scope.produtos || []), produto);

      const descricaoUnidade = produto.unidade.descricao_padrao;
      if (descricaoUnidade) {
        const unidade = UnidadesService.getMeasureUnitysFromDescription(descricaoUnidade);
        const unidadeDoSaldo = UnidadesService.getMeasureUnitysFromDescription(
          _.get(foundProduct, 'unidade.descricao_padrao')
        );

        if (unidadeDoSaldo.id) {
          produto.unidadeOriginal = unidadeDoSaldo;
        }

        if (unidade.id) {
          produto.unidade = unidade;
          produto.unidadeOriginal = produto.unidadeOriginal || unidade;
        }
      }
    }

    function mapApiLotesToUiFormat(lotes) {
      return (lotes || []).map(function(lote) {
        if (lote.nrLote) {
          return lote;
        }
        const saldos = Array.isArray(lote.saldo_fisico) ? lote.saldo_fisico : [];
        return {
          nrLote: lote.nr_lote,
          fisico: saldos.reduce(function(sum, sf) {
            return sum + (+sf.saldo_fisico || 0);
          }, 0),
          emUso: saldos.reduce(function(sum, sf) {
            return sum + (+sf.saldo_em_uso || 0);
          }, 0),
          dataValidadeLote: lote.dt_vencimento || null
        };
      });
    }

    // eslint-disable-next-line max-lines-per-function
    function getLotesSync(produto) {
      const deferred = $q.defer();

      const allProduto = findProduto(vm.allProdutos || [], produto);
      if (allProduto && Array.isArray(allProduto.lotes)) {
        produto.lotes = allProduto.lotes.filter(function(lote) {
          return lote.fisico + lote.emUso > 0 || lote.nrLote === produto.nr_lote;
        });
        deferred.resolve();
        return deferred.promise;
      }

      const filters = {
        item: produto.item_codigo,
        gleba_id: (vm.newData && vm.newData.gleba) ? vm.newData.gleba.id : null,
        tipo_item: produto.item_tipo,
        gleba_id: (vm.newData && vm.newData.gleba) ? vm.newData.gleba.id : null,
        nao_considerar_aplicacao_id: vm.aplicacao.id
      };

      ItensService.listItemsBalance(filters).then(function(response) {
        const items = response.data || [];
        const foundItem = items.find((i) => i.id === produto.item_codigo);
        const rawLotes = mapApiLotesToUiFormat(foundItem ? foundItem.lotes : []);
        produto.lotes = rawLotes.filter(function(lote) {
          return lote.fisico + lote.emUso > 0 || lote.nrLote === produto.nr_lote;
        });
        if (produto.nr_lote && !produto.lotes.find((lote) => lote.nrLote === produto.nr_lote)) {
          produto.lotes.push({ nrLote: produto.nr_lote, fisico: 0, emUso: 0 });
        }
        deferred.resolve();
      }, function(error) {
        console.error('Erro ao listar lotes do produto', error);
        deferred.reject();
      });

      return deferred.promise;
    }

    function updateLote(produto) {
      const deferred = $q.defer();

      getLotesSync(produto).then(function() {
        produto.lote = produto.lotes.find((lote) => lote.nrLote === produto.nr_lote);
        produto.nr_lote = (produto.lote || {}).nrLote;
        deferred.resolve();
      })
        .catch(deferred.reject);

      return deferred.promise;
    }
    // eslint-disable-next-line complexity
    function updateProduto(produto) {
      const deferred = $q.defer();

      updateDescricaoProduto(produto);
      produto.qt_dose = Number(produto.qt_dose);
      produto.qt_total = Number(produto.qt_total);
      produto.unidades = UnidadesService.getUnidadesCompativeis(produto.unidade);
      produto.old_qtd = parseFloat(produto.quantidadeTotal || produto.qt_total);
      produto.old_nr_lote = produto.nr_lote;

      if (_.get(vm.allProdutos, 'length')) {
        const filterProduto = findProduto(vm.allProdutos, produto);
        if (filterProduto) {
          produto.controla_lote = filterProduto.controla_lote;
          produto.saldo_fisico = _.get(filterProduto, 'saldo_fisico', 0);
          produto.saldo_em_uso = _.get(filterProduto, 'saldo_em_uso', 0);
          produto.saldo_receber = _.get(filterProduto, 'saldo_receber', 0);
        }
      }

      if (produto.controla_lote && produto.nr_lote) {
        updateLote(produto)
          .then(deferred.resolve)
          .catch(deferred.reject);
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function stockIsNegative(produto) {
      const controlaLote = produto.controla_lote || produto.controlaLote;
      if (!$rootScope.parametros.tem_controle_de_estoque || (controlaLote && !produto.lote)) {
        return false;
      }
      return ItensService.stockIsNegative(produto, vm.hasDepositInUse);
    }

    function useDepositInUse() {
      const propriedadeId = vm.aplicacao.gleba.cd_propriedade;
      return DepositosService.hasDepositInUse(propriedadeId).then(({ data }) => {
        vm.hasDepositInUse = data;
      });
    }

    function fixDose(produto) {
      if ($scope.isDecimalV2Enabled && produto._doseOnFocus !== produto.qt_dose) {
        produto.qt_dose = DecimalsService.truncateDoseOrQuantity(produto.qt_dose);
        changeDose(produto);
        delete produto._doseOnFocus;
      } else {
        produto.qt_dose = +Number(produto.qt_dose).toFixed(4);
      }
    }

    function changeQuantidadeTotal(produto) {
      const areaProduto = getArea(produto);
      let dose = 0;

      if ($scope.isDecimalV2Enabled) {
        const doseCalculated = DecimalsService.roundForCalculation(
          +produto.qt_total / areaProduto,
          DecimalsService.DECIMAL_PLACES_CALCULATION
        );
        dose = DecimalsService.truncateDoseOrQuantity(doseCalculated);
      } else {
        dose = Number((toNumber(produto.qt_total) / areaProduto).toFixed(4));
      }

      produto.qt_dose = dose * vm.fatorDose;
    }

    function fixQuantidadeTotal(produto) {
      if ($scope.isDecimalV2Enabled && produto._qtTotalOnFocus !== produto.qt_total) {
        produto.qt_total = DecimalsService.truncateDoseOrQuantity(produto.qt_total);
        changeQuantidadeTotal(produto);
        delete produto._qtTotalOnFocus;
      } else {
        produto.qt_total = +Number(produto.qt_total).toFixed(4);
      }
    }

    function startEditDose(produto) {
      produto._doseOnFocus = +produto.qt_dose;
    }

    function startEditQuantidadeTotal(produto) {
      produto._qtTotalOnFocus = +produto.qt_total;
    }

    function removeProduto(index) {
      vm.newData.produtos.splice(index, 1);
    }

    function specifyProductArea(produto) {
      return $q((resolve, reject) => {
        MessagesService.prompt(`Área aplicada de ${produto.descricao}`).then(function(data) {
          try {
            data = toNumber(data);
            if (data <= 0 || data > toNumber(vm.newData.area)) {
              MessagesService.alert('Valor inválido para área aplicada');
              reject();
            } else {
              produto.qt_area = data;

              if (data === toNumber(vm.newData.area)) {
                produto.qt_area = null;
              }
              vm.changeDose(produto);
              resolve();
            }
          } catch (error) {
            MessagesService.alert('Valor inválido para área aplicada');
            reject();
          }
        }, reject);
      });
    }

    function addLote($select, produto) {
      produto.nr_lote = $select ? $select.nrLote : null;
      produto.lote = $select || null;
    }

    // eslint-disable-next-line max-lines-per-function
    function getLotes(produto) {
      if (produto.loadingLotes || produto.lotes) {
        return (produto.lotes || []).filter((lote) => {
          const loteAlreadySelectedBySameProduct = vm.newData.produtos.some((newDataProduct) => {
            if (newDataProduct === produto) {
              return false;
            }
            const sameProduct = newDataProduct.id === produto.item_codigo ||
              newDataProduct.item_codigo === produto.item_codigo;
            return sameProduct && newDataProduct.nr_lote === lote.nrLote;
          });

          return !loteAlreadySelectedBySameProduct;
        });
      }

      produto.loadingLotes = true;
      const filters = {
        item: produto.item_codigo,
        tipo_item: produto.item_tipo,
        gleba_id: (vm.newData && vm.newData.gleba) ? vm.newData.gleba.id : null,
        nao_considerar_aplicacao_id: vm.aplicacao.id
      };

      ItensService.listItemsBalance(filters)
        .then((response) => {
          const items = response.data || [];
          const foundItem = items.find((i) => i.id === produto.item_codigo);
          const rawLotes = mapApiLotesToUiFormat(foundItem ? foundItem.lotes : []);
          produto.lotes = rawLotes.filter(function(lote) {
            return lote.fisico + lote.emUso > 0;
          });
        })
        .catch((error) => {
          console.error('Erro ao listar lotes do produto', error);
        })
        .finally(function() {
          produto.loadingLotes = false;
        });
    }

    function fetchPainelProducts(descricao) {
      const params = { ...getModalParams(), ...(descricao ? { descricao } : {}) };
      return RecomendacoesService.listItemsBalance(params)
        .then(function(data) {
          return normalizeProdutosLotes(data.data);
        });
    }

    function fetchPainelByIds(ids) {
      return RecomendacoesService.listItemsBalance({
        ...getModalParams(),
        item: ids.join(','),
        tipo_item: 1
      }).then(function(data) {
        return normalizeProdutosLotes(data.data);
      });
    }

    function openProductModal() {
      LoadingService.showLoading();
      RecomendacoesService.listItemsBalance(getModalParams())
        .then(function(data) {
          return ProdutoModalService.buildModalList(
            normalizeProdutosLotes(data.data), vm.newData.produtos, fetchPainelByIds
          );
        })
        .then(function(fullList) {
          LoadingService.hideLoading();
          const selectedProducts = ProdutoModalService.findSelected(fullList, vm.newData.produtos);
          return ProdutoModalService.open(fullList, selectedProducts, {
            fetchProducts: fetchPainelProducts
          });
        })
        .then((products) => ProdutoModalService.mergeProducts(products, vm.newData.produtos))
        .then((products) => products.forEach((prod) => vm.addProduto(prod)))
        .catch(function(error) {
          LoadingService.hideLoading();
          if (error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          }
        });
    }

    function getModalParams() {
      return {
        gleba_id: (vm.newData && vm.newData.gleba) ? vm.newData.gleba.id : null,
        operacao_item: getOperacaoItemEstoque(),
        data: vm.newData.dataInicial,
        nao_considerar_aplicacao_id: vm.aplicacao.id
      };
    }

    function cancel() {
      let activeApplicationsTab = null;
      if (vm.tipoOperacao === $rootScope.parametros.operacao_correcao_solo.id) {
        activeApplicationsTab = 'correcaoSolo';
      } else if (vm.tipoOperacao === $rootScope.parametros.operacao_adubacao.id) {
        activeApplicationsTab = 'adubacao';
      } else if (vm.tipoOperacao === $rootScope.parametros.operacao_semeadura.id) {
        activeApplicationsTab = 'plantio';
      }
      $location.search({
        ...$routeParams,
        sidebar: 'applications',
        activeApplication: _.get(vm.aplicacao, 'id', null),
        activeApplicationsTab
      });
    }

    function save(form) {
      const isValid = validateAplicacao(form);

      if (isValid) {
        LoadingService.showLoading();

        const data = newDataToParams();

        AplicacoesService.update(vm.aplicacao.id, data)
          .then(() => {
            MessagesService.alert('Aplicação editada com sucesso!');
            cancel();
          })
          .catch((error) => {
            let message = 'Erro ao editar aplicação. Verifique os dados e tente novamente.';
            if (_.get(error.data, 'message')) {
              message = `Erro ao editar aplicação: ${error.data.message}`;
            }

            MessagesService.alert(message);
            console.error('Erro ao editar aplicação', error);
          })
          .finally(LoadingService.hideLoading);
      }
    }

    function newDataToParams() {
      const maquina = _.get(vm.newData.maquina, 'id', 0);
      const { start, end } = getStartAndEnd();
      return {
        aplicacoes: [{
          atividade: _.get(vm.newData.atividade, 'id'),
          cd_gleba: vm.newData.gleba.id,
          safra: vm.newData.safra.id,
          area: vm.newData.area,
          nr_tanques: vm.newData.nr_tanques,
          itens_attributes: itensAttributes(vm.newData.produtos),
          dt_ini: start,
          dt_fim: end,
          obs: vm.newData.observacao,
          vazao: vm.newData.vazao,
          atributo_attributes: {
            capacidade_tanque: vm.newData.capacidade,
            id: _.get(vm.aplicacao, 'allData.atributo.id'),
            maquina_id: maquina > 0 ? maquina : null,
            iniciado_em: start,
            encerrado_em: end
          }
        }]
      };
    }

    function getStartAndEnd() {
      const start = moment(vm.newData.dataInicial)
        .set({
          hour: moment(vm.newData.horaInicial).format('H'),
          minute: moment(vm.newData.horaInicial).format('m'),
          second: 0
        })
        .format('Y-MM-DD HH:mm:ss');
      const end = moment(vm.newData.dataFinal)
        .set({
          hour: moment(vm.newData.horaFinal).format('H'),
          minute: moment(vm.newData.horaFinal).format('m'),
          second: 0
        })
        .format('Y-MM-DD HH:mm:ss');
      return { start, end };
    }

    function itensAttributes(produtos) {
      return produtos.map((produto) => {
        const item = {
          item_tipo: produto.item_tipo,
          item_codigo: produto.item_codigo,
          unidade: produto.unidade.nomeSistema || produto.unidade.id,
          qt_dose: $scope.isDecimalV2Enabled ?
            DecimalsService.truncateDoseOrQuantity(produto.qt_dose) :
            produto.qt_dose,
          qt_total: $scope.isDecimalV2Enabled ?
            DecimalsService.truncateDoseOrQuantity(produto.qt_total) :
            produto.qt_total,
          nr_lote: (produto.lote || {}).nrLote || produto.nr_lote
        };

        if (typeof produto.qt_area !== 'undefined') {
          item.qt_area = produto.qt_area;
        }

        return item;
      });
    }

    function validateAplicacao(form) {
      let isValid = true;
      if (form.$invalid) {
        isValid = false;
      }

      if (!(vm.newData.produtos || []).length) {
        MessagesService.alert('Informe pelo menos um produto.');
        isValid = false;
      }

      const produtosValidos = validateProdutos();

      if (!produtosValidos.valid) {
        MessagesService.alert(produtosValidos.message);
        return;
      }

      if (!validateLoteProdutos()) {
        MessagesService.alert('Informe o número do lote para todos produtos.');
        isValid = false;
      }

      if (!validateDates()) {
        // eslint-disable-next-line max-len
        MessagesService.alert('Verifique a data final e inicial informadas. A data inicial não pode ser após a final, nem a final antes da inicial.');
        isValid = false;
      }

      return isValid;
    }

    function validateProdutos() {
      if (vm.newData.produtos.length === 0) {
        return { valid: false, message: MESSAGE_WITHOUT_PRODUCT };
      }

      const hasProdutosInvalidos = vm.newData.produtos.some(function(produto) {
        const doseInvalida = !produto.qt_dose || produto.qt_dose < MIN_DOSE_VALOR;
        const unidadeInvalida = !(produto.unidade || {}).abreviatura;
        return doseInvalida || unidadeInvalida;
      });


      if (hasProdutosInvalidos) {
        return { valid: false, message: MESSAGE_INVALID_PRODUCT };
      }

      return { valid: true };
    }

    function validateLoteProdutos() {
      return (vm.newData.produtos || []).reduce((result, produto) => {
        const controlaLote = !!produto.controla_lote;
        return result && (!controlaLote || produto.nr_lote);
      }, true);
    }

    function updateHour(date, dateHour) {
      date.setHours(dateHour.getHours());
      date.setMinutes(dateHour.getMinutes());
    }

    function updateDate(dateHour, date) {
      dateHour.setDate(date.getDate());
      dateHour.setMonth(date.getMonth());
      dateHour.setYear(date.getFullYear());
    }

    function validateDates() {
      const dataInicial = new Date(vm.newData.dataInicial);
      const horaInicial = new Date(vm.newData.horaInicial);
      updateHour(dataInicial, horaInicial);
      updateDate(horaInicial, dataInicial);

      const dataFinal = new Date(vm.newData.dataFinal);
      const horaFinal = new Date(vm.newData.horaFinal);
      updateHour(dataFinal, horaFinal);
      updateDate(horaFinal, dataFinal);

      return moment(dataInicial).isSameOrBefore(dataFinal) &&
        moment(horaInicial).isBefore(horaFinal);
    }

    function getOperacaoItemEstoque() {
      let operacao = 'pulverizacao';

      if (vm.aplicacao) {
        const parametros = $rootScope.parametros;
        if (vm.tipoOperacao === parametros.operacao_semeadura.id) {
          operacao = 'cultivar,outros_semeadura';
        } else if (vm.tipoOperacao === parametros.operacao_correcao_solo.id) {
          operacao = 'correcao_solo';
        } else if (vm.tipoOperacao === parametros.operacao_adubacao.id) {
          operacao = 'outros_semeadura';
        }
      }

      return operacao;
    }

    function changeConsumo() {
      if (!!vm.newData.vazao && vm.newData.nr_tanques) {
        const area = (vm.newData.nr_tanques * vm.newData.capacidade) / vm.newData.vazao;
        vm.newData.newArea = $scope.isDecimalV2Enabled ?
          DecimalsService.truncateArea(area) :
          Number(area.toFixed(2));
        vm.changeArea();
      }
    }

    function carregarAplicacaoSeNecessario() {
      if (vm.application && vm.application.allData) {
        vm.aplicacao = vm.application;
        return $q.resolve();
      }
      if (!$routeParams.activeApplication) {
        return $q.reject(new Error('activeApplication não informado'));
      }
      return AplicacoesService.get($routeParams.activeApplication).then((response) => {
        const fullData = response.data || {};
        vm.aplicacao = { ...fullData, allData: fullData };
      });
    }

    function inicializarAplicacao() {
      vm.loadingAplicacao = true;
      $rootScope.initialize
        .then(carregarAplicacaoSeNecessario)
        .then(() => {
          vm.tipoOperacao = _.get(vm.aplicacao, 'allData.operacao.id', null);
          vm.aplicacao.auditoria_id = vm.aplicacao.allData.auditoria_id;
          vm.newData = setupData();
        })
        .then(loadData)
        .catch((error) => {
          console.error('Aplicação não existe no escopo', error);
          MessagesService.alert('Não foi possível carregar a aplicação');
          cancel();
        })
        .finally(() => {
          vm.loadingAplicacao = false;
        });
    }

    $scope.$on('editApplication', inicializarAplicacao);
  }
}());
